/**
 * Static instrument demo for marketing + auth left column (no live API).
 * `preview` mode uses muted non-button pills so auth pages do not look clickable.
 */
export function MarketingInstrumentDemo({
  variant = 'hero',
  className = '',
  preview = false,
}) {
  const compact = variant === 'compact';
  const showCarryList = !compact;

  const commandLabels = ['Log meal', 'Recovery', 'Quick-fill'];
  const carryItems = ['2 gels · 60g', '600ml', '1 banana'];

  return (
    <div
      className={[
        'space-y-3',
        compact ? 'max-w-sm' : '',
        preview ? 'instrument-preview-demo pointer-events-none select-none' : '',
        className,
      ].filter(Boolean).join(' ')}
      aria-hidden={preview ? true : compact ? undefined : true}
      role={preview ? 'img' : undefined}
      aria-label={preview ? 'Product preview illustration' : undefined}
    >
      <div className="instrument-fuel-tile" data-metric="wkg">
        <div className="flex items-start justify-between gap-3">
          <div className="min-w-0 flex-1">
            <p className="instrument-page-eyebrow !mb-1">Bonk risk</p>
            <p className="instrument-data-value text-3xl sm:text-4xl">38</p>
            <p className="mt-1 text-sm text-[var(--text-secondary)]">
              Low risk for today&apos;s 90 min tempo
            </p>
          </div>
          <div className="instrument-stat-cell shrink-0 px-3 py-2 text-center" data-metric="wkg">
            <p className="text-[10px] uppercase tracking-wide text-[var(--text-muted)]">Band</p>
            <p className="font-display text-sm font-bold text-[var(--data-wkg)]">LOW</p>
          </div>
        </div>
        <div className="mt-3 instrument-macro-row" data-metric="wkg">
          <div className="instrument-macro-track h-2">
            <div className="instrument-macro-fill h-full rounded-full" style={{ width: '38%' }} />
          </div>
        </div>
        <div className="mt-3 grid grid-cols-3 gap-2">
          {[
            ['Carbs', '60g/h', 'carbs'],
            ['Fluid', '750ml/h', 'hydration'],
            ['Score', '82', 'score'],
          ].map(([lab, val, metric]) => (
            <div key={lab} className="instrument-stat-cell" data-metric={metric}>
              <p className="instrument-page-eyebrow !mb-0 !text-[10px]">{lab}</p>
              <p className="font-display text-sm font-bold tabular-nums mt-1">{val}</p>
            </div>
          ))}
        </div>
      </div>

      {preview ? (
        <div className="instrument-fuel-tile" data-metric="score">
          <p className="instrument-page-eyebrow !mb-2">Sample commands</p>
          <div className="flex flex-wrap gap-2">
            {commandLabels.map((label, index) => (
              <span
                key={label}
                className={[
                  'instrument-preview-pill',
                  index === 0 ? 'instrument-preview-pill-accent' : '',
                ].filter(Boolean).join(' ')}
              >
                {label}
              </span>
            ))}
          </div>
        </div>
      ) : (
        <div className="instrument-fuel-strip !py-2.5">
          <div className="instrument-fuel-strip-row">
            <span className="btn-primary shrink-0 pointer-events-none text-sm">Log meal</span>
            <span className="btn-chip shrink-0 pointer-events-none text-sm">Recovery</span>
            <span className="btn-chip shrink-0 pointer-events-none text-sm">Quick-fill</span>
          </div>
        </div>
      )}

      {showCarryList ? (
        <div className="instrument-fuel-tile" data-metric="carbs">
          <p className="instrument-page-eyebrow !mb-2">Carry list</p>
          <div className="flex flex-wrap gap-2">
            {carryItems.map((item) => (
              <span
                key={item}
                className={
                  preview
                    ? 'instrument-preview-pill'
                    : 'btn-chip !min-h-[36px] !h-9 !px-3 text-xs pointer-events-none'
                }
              >
                {item}
              </span>
            ))}
          </div>
        </div>
      ) : null}
    </div>
  );
}
